import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'

const FromCaixa = ({ fechaModal, caixa_id, filial_id}) => {

  const [form, setForm] = useState('')
  const [loading, setLoading] = useState(true)

  const editCaixa = (caixa_id, filial_id) => {
    const url = rotas.caixa+filial_id+'/'+caixa_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success && ret.lista != '') {
        let caixa = ret.lista[0]

        caixa.caixa_dinheiro      = parseFloat(caixa.receb_dinheiro) + parseFloat(caixa.vendas_dinheiro)
        caixa.caixa_cheque        = parseFloat(caixa.receb_cheque) + parseFloat(caixa.vendas_cheque)
        caixa.caixa_cheque_pre    = parseFloat(caixa.receb_cheque_pre) + parseFloat(caixa.vendas_cheque_pre)
        caixa.caixa_cartao        = parseFloat(caixa.receb_cartao) + parseFloat(caixa.vendas_cartao)
        caixa.caixa_crediario     = parseFloat(caixa.vendas_crediario)
        caixa.caixa_parcelamento  = parseFloat(caixa.vendas_parcelamento)
        caixa.caixa_outros        = parseFloat(caixa.vendas_outros)
        caixa.caixa_recarga       = parseFloat(caixa.recargas) + parseFloat(caixa.receb_outros)
        caixa.caixa_suprimento    = parseFloat(caixa.suprimento)
        caixa.caixa_sangria       = parseFloat(caixa.sangria)
        caixa.caixa_devolucoes    = parseFloat(caixa.devolucoes)
        caixa.caixa_total         = (parseFloat(caixa.caixa_dinheiro) + parseFloat(caixa.caixa_cheque) + parseFloat(caixa.caixa_cheque_pre) + parseFloat(caixa.caixa_suprimento))-caixa.caixa_sangria
        caixa.valor_abertura      = parseFloat(caixa.valor_abertura)
        caixa.vendas_cartao       = parseFloat(caixa.vendas_cartao)
        caixa.vendas_cheque       = parseFloat(caixa.vendas_cheque)
        caixa.vendas_cheque_pre   = parseFloat(caixa.vendas_cheque_pre)
        caixa.vendas_crediario    = parseFloat(caixa.vendas_crediario)
        caixa.vendas_dinheiro     = parseFloat(caixa.vendas_dinheiro)
        caixa.vendas_outros       = parseFloat(caixa.vendas_outros)
        caixa.vendas_parcelamento = parseFloat(caixa.vendas_parcelamento)
        caixa.vendas_subsidio     = parseFloat(caixa.vendas_subsidio)
        caixa.desconto_vendas     = parseFloat(caixa.desconto_vendas)
        caixa.devolucoes_vista    = parseFloat(caixa.devolucoes_vista)
        caixa.devolucoes          = parseFloat(caixa.devolucoes)
        caixa.total_vendas        = parseFloat(caixa.total_vendas)
        caixa.receb_dinheiro      = parseFloat(caixa.receb_dinheiro)
        caixa.receb_cheque        = parseFloat(caixa.receb_cheque)
        caixa.receb_cheque_pre    = parseFloat(caixa.receb_cheque_pre)
        caixa.receb_cartao        = parseFloat(caixa.receb_cartao)
        caixa.receb_outros        = parseFloat(caixa.receb_outros)
        caixa.outras_lojas        = parseFloat(caixa.outras_lojas)
        caixa.total_recebimento   = parseFloat(caixa.total_recebimento)
        caixa.frete               = parseFloat(caixa.frete)

        setForm(caixa)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(caixa_id != ''){
      editCaixa(caixa_id, filial_id)
    }else{
      setForm('')
      setLoading(false)
    }
  },[])


  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <Row>
        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Caixa</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "dinheiro"
                    id    = "dinheiro"
                    value = {form.caixa_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "cheque"
                    id    = "cheque"
                    value = {form.caixa_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "cheque_pre"
                    id    = "cheque_pre"
                    value = {form.caixa_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cartão</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "cartao"
                    id    = "cartao"
                    value = {form.caixa_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Crediário</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "crediario"
                    id    = "crediario"
                    value = {form.caixa_crediario.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Parcelamento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "parcelamento"
                    id    = "parcelamento"
                    value = {form.caixa_parcelamento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "outros"
                    id    = "outros"
                    value = {form.caixa_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Recargas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "recarga"
                    id    = "recarga"
                    value = {form.caixa_recarga.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Suprimento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "suprimento"
                    id    = "suprimento"
                    value = {form.caixa_suprimento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Sangria</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ff7f7f'}}
                    name  = "sangria"
                    id    = "sangria"
                    value = {form.caixa_sangria.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ffb2b2'}}
                    name  = "caixa_devolucoes"
                    id    = "caixa_devolucoes"
                    value = {form.caixa_devolucoes.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "caixa_total"
                    id    = "caixa_total"
                    value = {form.caixa_total.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Vendas</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_dinheiro"
                    id    = "vendas_dinheiro"
                    value = {form.vendas_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque"
                    id    = "vendas_cheque"
                    value = {form.vendas_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque_pre"
                    id    = "vendas_cheque_pre"
                    value = {form.vendas_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cartão</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cartao"
                    id    = "vendas_cartao"
                    value = {form.vendas_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Crediário</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_crediario"
                    id    = "vendas_crediario"
                    value = {form.vendas_crediario.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Parcelamento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_parcelamento"
                    id    = "vendas_parcelamento"
                    value = {form.vendas_parcelamento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_outros"
                    id    = "vendas_outros"
                    value = {form.vendas_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ffb2b2'}}
                    name  = "desconto_vendas"
                    id    = "desconto_vendas"
                    value = {form.desconto_vendas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subsidio</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#66b2ff'}}
                    name  = "vendas_subsidio"
                    id    = "vendas_subsidio"
                    value = {form.vendas_subsidio.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções A Vista</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ffb2b2'}}
                    name  = "devolucoes_vista"
                    id    = "devolucoes_vista"
                    value = {form.devolucoes_vista.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ffb2b2'}}
                    name  = "devolucoes"
                    id    = "devolucoes"
                    value = {form.devolucoes.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total Vendas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ff7f7f'}}
                    name  = "total_vendas"
                    id    = "total_vendas"
                    value = {form.total_vendas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Recebimentos</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "receb_dinheiro"
                    id    = "receb_dinheiro"
                    value = {form.receb_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "receb_cheque"
                    id    = "receb_cheque"
                    value = {form.receb_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "receb_cheque_pre"
                    id    = "receb_cheque_pre"
                    value = {form.receb_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cartão</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "receb_cartao"
                    id    = "receb_cartao"
                    value = {form.receb_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "receb_outros"
                    id    = "receb_outros"
                    value = {form.receb_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outras Lojas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ffb2b2'}}
                    name  = "outras_lojas"
                    id    = "outras_lojas"
                    value = {form.outras_lojas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subtotal</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    // style  = {{background: '#ff7f7f'}}
                    name  = "total_recebimento"
                    id    = "total_recebimento"
                    value = {form.total_recebimento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Número do caixa</span>
              <span>{form.caixa_id}</span>
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Loja</span>
              <span>{form.fantasia}</span>
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              {form.abertura}
            </Col>
          </div>
        </Col>
        <Col className="text-center p-3">
          <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
        </Col>
      </Row>
    )
  }

}


export default FromCaixa
